module.exports = __webpack_public_path__ + "img/multiple-gateway.b768e04a.svg";